import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";

const ReferralHistory = () => {
  const referralData = [
    {
      id: 1,
      userDetail: "John Doe",
      email: "john@example.com",
      phone: "9876543210",
      referralDate: "2025-02-15",
      userLoginDate: "2025-02-20",
      earnedPoints: 10,
      referralCode: "REF123",
      status: "Earned",
    },
    {
      id: 2,

      userDetail: "Alice Smith",
      email: "alice@example.com",
      phone: "9876543210",
      referralDate: "2025-02-10",
      userLoginDate: "2025-02-18",
      earnedPoints: 10,
      referralCode: "REF456",
      status: "Pending",
    },
    {
      id: 3,

      userDetail: "Michael Brown",
      email: "mike@example.com",
      phone: "9876543210",
      referralDate: "2025-01-25",
      userLoginDate: "2025-01-30",
      earnedPoints: 10,
      referralCode: "REF789",
      status: "Earned",
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Reffered To</TableCell>
            <TableCell>Reffered  On</TableCell>

            <TableCell>Earned Points</TableCell>
            <TableCell>Referral Code</TableCell>
            <TableCell>Referral Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {referralData.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell> <div className="user_block"> <p> <b> {row.userDetail}</b> <span>{row.email}</span> <span>{row.phone}</span> </p></div></TableCell>
              <TableCell>{row.referralDate}</TableCell>

              <TableCell>{row.earnedPoints}</TableCell>
              <TableCell>{row.referralCode}</TableCell>
              <TableCell>       <p
                className={`status_btn dark ${row.status === "Earned"
                    ? "c_success"
                    : row.status === "Pending"
                      ? "c_danger"
                      : "c_warning"
                  }`}
              >

                {row.status}
              </p></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReferralHistory;
